import { Fragment } from "react";

import { prop, define } from "@/components/builder/utils";

import BasePreview from "../../../base";
import { useFormFieldContext } from "../context";

function FormH4Preview({ ...props }) {
  const { field: { label } } = useFormFieldContext()

  return <BasePreview {...props}>
    <h4>{label}</h4>
  </BasePreview>
}

export default define('form-heading-h4', FormH4Preview, Fragment)
  .shared(prop.share('FormH4', 'form-heading-h4'))
  .property(prop.predefined.customClass())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.typography())
  .build()

